import _regeneratorRuntime from "D:\\new-code\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import List from "@/components/List.vue";
export default {
  name: "CourseComment",
  components: {
    List: List
  },
  props: {
    comment: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    courseId: {}
  },
  computed: {
    params: function params() {
      return {
        id: this.courseId
      };
    }
  },
  methods: {
    onComplaint: function onComplaint(comment) {
      this.$emit("complaint", comment.id);
    },
    onDelete: function () {
      var _onDelete = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(comment) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$promiseConfirm("删除后，该内容将不再展示，是否确认？", {
                  type: "warning"
                });

              case 2:
                _context.next = 4;
                return this.$http.delete("/api/app/course/comment/" + comment.id);

              case 4:
                this.$refs.list.refresh();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onDelete(_x) {
        return _onDelete.apply(this, arguments);
      }

      return onDelete;
    }(),
    onLoad: function onLoad(data) {
      this.$emit("load", data);
    }
  }
};